import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from "redux";
import { MainRatesTable } from 'app/pages/AgentPricing/components/RatesTableWidget';
import RateFinderWidget from 'app/pages/AgentPricing/components/RateFinderWidget';
import { getAgentId, getIsAgentCommissionBlocked } from 'app/pages/AgentPricing/modules/RefData';
import { getRatesTable } from 'app/pages/AgentPricing/modules/RatesTableWidget/selectors';
import { AgentCommissionStatus } from 'app/shared/model/AgentCommissionDto';
import { Button, Card, Alert, Space } from 'antd';
import { EditOutlined, PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './AgentCommissionSection.css';
import {getSelectedDivisionId} from "app/pages/AgentPricing/utils/division";

export interface AgentCommissionSectionProps {}

interface StateProps {
    editRatesUrl: string, 
    hasRatesTable: boolean,
    isAgentStopped: boolean
}


interface DispatchProps {
}

type InternalProps = StateProps & DispatchProps; 

const AgentUnavailableBanner = () => (
    <Alert
        title="Agent is not available."
        description="This agent has been stopped. Please reactivate it before proceeding to add commissions."
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        style={{ marginBottom: 16 }}
    />
);

const AgentCommissionSection = (props: InternalProps) => {
    if (props.hasRatesTable) {
        return (
            <div className="agent-commission-section">
                {props.isAgentStopped && <AgentUnavailableBanner />}
                <MainRatesTable readonly />
                <div className="footer" style={{ marginTop: 24, marginBottom: 24, textAlign: 'right' }}>
                    <Button 
                        type="primary" 
                        href={props.isAgentStopped ? undefined : props.editRatesUrl}
                        icon={<EditOutlined />}
                        size="large"
                        disabled={props.isAgentStopped}
                    >
                        Edit rates
                    </Button>
                </div>
                {!props.isAgentStopped && <RateFinderWidget />}
            </div>
        );
    } else {
        return (
            <Card className="agent-commission-section">
                {props.isAgentStopped ? (
                    <AgentUnavailableBanner />
                ) : (
                    <Alert
                        title="No agent commission"
                        description="No commission has been setup for this agent."
                        type="info"
                        showIcon
                        icon={<InfoCircleOutlined />}
                        style={{ marginBottom: 16 }}
                    />
                )}
                <Space>
                    <Button 
                        type="primary" 
                        href={props.isAgentStopped ? undefined : props.editRatesUrl}
                        icon={<PlusOutlined />}
                        disabled={props.isAgentStopped}
                    >
                        Setup commission
                    </Button>
                </Space>
            </Card>
        );
    }
};

const mapStateToProps = (state:any) => {
    const agentId = getAgentId(state);
    const divisionId = getSelectedDivisionId();

    const divPart = divisionId ? `&divisionId=${encodeURIComponent(String(divisionId))}` : '';

    return {
        editRatesUrl: '/agents/edit-rates?id=' + encodeURIComponent(agentId) + divPart,
        hasRatesTable: getRatesTable(state).status !== AgentCommissionStatus.New,
        isAgentStopped: getIsAgentCommissionBlocked(state)
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>, ownProps: AgentCommissionSectionProps) => ({
    
})

export default connect(mapStateToProps, mapDispatchToProps)(AgentCommissionSection);
